import { IExample } from "../../../Components/Examples.Types";

import BasicDropdownExample from "./examples/BasicDropdown.Example";
import DropdownLoadingExample from "./examples/DropdownLoading.Example";
import DropdownDefaultSelectionExample from "./examples/DropdownDefaultSelection.Example";
import DropdownSingleSelectExample from "./examples/DropdownSingleSelect.Example";
import DropdownMultiSelectExample from "./examples/DropdownMultiSelect.Example";
import DropdownAdvancedExample from "./examples/DropdownAdvanced.Example";
import DropdownButtonExample from "./examples/DropdownButton.Example";

export default [
    {
        title: "Basic dropdown",
        component: BasicDropdownExample,
        code: require("!raw-loader!./examples/BasicDropdown.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Single-select Dropdown",
        component: DropdownSingleSelectExample,
        code: require("!raw-loader!./examples/DropdownSingleSelect.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Dropdown button",
        component: DropdownButtonExample,
        code: require("!raw-loader!./examples/DropdownButton.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Dropdown with default selection",
        component: DropdownDefaultSelectionExample,
        code: require("!raw-loader!./examples/DropdownDefaultSelection.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Multi-select Dropdown",
        component: DropdownMultiSelectExample,
        code: require("!raw-loader!./examples/DropdownMultiSelect.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Advanced Dropdown",
        component: DropdownAdvancedExample,
        code: require("!raw-loader!./examples/DropdownAdvanced.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Dropdown with loading",
        component: DropdownLoadingExample,
        code: require("!raw-loader!./examples/DropdownLoading.Example.tsx"),
        dependencies: {
            "Dropdown.css": require("!raw-loader!./examples/Dropdown.css")
        }
    }
] as IExample[];
